export const REVIEWS_PAGE_SIZE = 10;
export const REVIEWS_MIN_COUNT = 2;
export const ORGANIZATION_REVIEWS_MIN_COUNT = 4;
export const REVIEWS_COUNT = 4;

export const DEFAULT_REVIEW_PARAMS = {
  OrderBy: 'highRateFirst',
  Rated: 'good',
  pageSize: REVIEWS_PAGE_SIZE,
};

export const ORGANIZATION_TYPES = {
  BANK: 'bank',
  INSURANCE: 'strakhovaja-kompanija',
  MFO: 'mikrofinansovaja-organizacija',
  EDUCATION: 'shkola',
  FOREIGNBANK: 'foreignBank',
  BOOKMAKER: 'bookmaker',
  Other: 'other',
  Broker: 'broker',
};
